module.exports = __webpack_public_path__ + "static/media/photo_10.3404cfc4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_10.jpg
// module id = 1643
// module chunks = 0